define('OutSystems/ReactWidgets/Throttling',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Throttling = void 0;
    var Throttling = (function () {
        function Throttling() {
            this.last = 0;
        }
        Throttling.prototype.dispose = function () {
            clearTimeout(this.deferTimerHandle);
            if (this.timeoutFunction) {
                this.timeoutFunction();
            }
        };
        Throttling.prototype.throttle = function (fn, effectiveInterval) {
            var _this = this;
            if (effectiveInterval === void 0) { effectiveInterval = Throttling.DefaultThrottlingInterval; }
            var now = new Date().valueOf();
            if (this.last && now < this.last + effectiveInterval) {
                clearTimeout(this.deferTimerHandle);
                this.timeoutFunction = function () {
                    _this.last = now;
                    _this.timeoutFunction = null;
                    fn();
                };
                this.deferTimerHandle = setTimeout(this.timeoutFunction, effectiveInterval);
            }
            else {
                this.last = now;
                fn();
            }
        };
        Throttling.DefaultThrottlingInterval = 200;
        Throttling.CustomThrottlingRuntimeAttribute = "data-throttlemilliseconds";
        Throttling.CustomThrottlingProperty = "onchange-throttle-milliseconds";
        return Throttling;
    }());
    exports.Throttling = Throttling;
});
//# sourceMappingURL=Throttling.js.map;
